<template>
  <v-dialog v-model="dialog" persistent max-width="500">
    <v-card>
      <v-card-title>
        <v-icon left color="success">mdi-check-circle</v-icon>
        Complete Task
      </v-card-title>
      <v-card-text v-if="task">
        <div class="mb-3">
          <strong>{{ task.task ? task.task.title : "" }}</strong>
          <div
            v-if="task.task && task.task.description"
            class="body-2 grey--text text--darken-1 mt-1"
            style="white-space: pre-wrap"
          >
            {{ task.task.description }}
          </div>
        </div>
        <v-textarea
          dense
          v-model="completion_note"
          label="Completion Note (optional)"
          placeholder="Describe what was done..."
          outlined
          rows="3"
          counter="500"
          maxlength="500"
        ></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">Cancel</v-btn>
        <v-btn color="success" :loading="loading" @click="submit">
          <v-icon left>mdi-check</v-icon>
          Mark Complete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    value: { type: Boolean, default: false },
    task: { type: Object, default: null },
  },
  data() {
    return {
      completion_note: "",
      loading: false,
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.completion_note = "";
      }
    },
  },
  methods: {
    ...mapActions({
      complete_task_log: "reminder/complete_task_log",
      set_notification: "notification/set_notification",
    }),
    close() {
      this.dialog = false;
    },
    submit() {
      if (!this.task || this.loading) return;
      this.loading = true;
      this.complete_task_log({
        logId: this.task.id,
        completion_note: this.completion_note,
      })
        .then(() => {
          this.loading = false;
          this.set_notification({
            message: "Task completed successfully!",
            type: "success",
          });
          this.$emit("completed");
          this.close();
        })
        .catch((err) => {
          this.loading = false;
          const status = err.response ? err.response.status : 0;
          if (status === 422) {
            // Task was already completed – still refresh the table
            this.set_notification({
              message: "Task was already completed.",
              type: "info",
            });
            this.$emit("completed");
            this.close();
          } else {
            this.$alert({
              title: "Error",
              message: err.response ? err.response.data.error : err.message,
              color: "error",
              icon: "mdi-alert-circle",
            });
          }
        });
    },
  },
};
</script>
